module.exports = __webpack_public_path__ + "img/right-arrow.3e9b532c.png";